import styled from 'styled-components'

export const Container = styled.main`
    position: relative;
`
interface PageContentProps {
    useHeader?: boolean
}

export const PageContent = styled.div<PageContentProps>`
    width: 100%;
    margin: 0 auto;
    font-family: 'Dasa Sans' !important;
`
export const Loading = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.2);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
